export const INTERNAL_DIMENSIONS = ["相信", "眷恋", "不服", "远方", "孤独", "狂欢"] as const;
export type InternalDimension = (typeof INTERNAL_DIMENSIONS)[number];
export type DisplayDimension = "相信" | "眷恋" | "倔强" | "远方" | "孤独" | "狂欢";
export type PersonaId = `T${string}`;

export interface Song {
  album: string;
  song: string;
  weights: Record<InternalDimension, number>;
  themes: string[];
  psych_core: string;
  base_reading: string;
  branches: Partial<Record<`${InternalDimension}高`, string>>;
  affinity: PersonaId[];
  combo_tags: string[];
  compact: string;
}

export interface WmlstiMaster {
  version: string;
  status: string;
  completed_albums: string[];
  completed_songs: number;
  total_songs: number;
  progress_percent: number;
  type_names: Record<PersonaId, string>;
  combo_rules_file: string;
  content_revision?: string;
  songs: Song[];
}

export interface ComboRule {
  id: string;
  name: string;
  when: Record<string, number>;
  copy: string;
}

export interface PersonaCopy {
  title: string;
  judgement: string;
  body: string;
}

export interface Classification {
  personaId: PersonaId;
  percentiles: Record<InternalDimension, number>;
  coreDimensions: InternalDimension[];
}

export type SelectionMap = Record<string, string>;

export interface ExpandedSong {
  song: Song;
  branchKey?: `${InternalDimension}高`;
  branchCopy?: string;
  explainScore: number;
}

export interface OfficialResult {
  classification: Classification;
  persona: PersonaCopy;
  selectedSongs: Song[];
  expandedSongs: ExpandedSong[];
  comboRule?: ComboRule;
}
